import HeaderUserAvatar from "./HeaderUserAvatar";

export default HeaderUserAvatar;
